import type { ReactNode } from 'react';

/**
 * The ONE canonical "expanded row" for every expandable table in the app: a full-width tinted
 * strip (bg-surface-2) bounded top+bottom, indented under the parent row and marked by a left
 * brand accent rail — so nested detail always reads as a distinct sub-section of the row above.
 *
 * Used by TwDataTable, the ui DataTable and the bespoke StockPage so their expansions stay
 * pixel-identical. Put the row's nested content inside — a SELF-HEADED sub-table (its own column
 * headers) when the child is a collection, or a bordered key/value grid for single-record detail.
 * Never reuse the parent's column grid with a "↳" connector; that reads as part of the parent.
 */
export function ExpandedRow({ colSpan, children }: { colSpan: number; children: ReactNode }) {
  return (
    <tr className="bg-surface-2">
      <td colSpan={colSpan} className="border-y border-line bg-surface-2 p-0">
        {/* The tint bleeds RIGHTWARD out of the brand accent rail and dies away across the strip, so
            the rail reads as the source of the colour rather than as a stripe stuck to the edge. */}
        <div className="border-l-2 border-brand-500/40 bg-linear-to-r from-brand-500/[0.07] to-transparent to-60% py-3 pr-4 pl-10">{children}</div>
      </td>
    </tr>
  );
}
